// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-enter-active[data-v-a6c710dc],.list-leave-active[data-v-a6c710dc]{transition:all 1s}.list-enter[data-v-a6c710dc],.list-leave-to[data-v-a6c710dc]{opacity:0}.p-mypage__order--preorder[data-v-a6c710dc]{color:#f06292}", ""]);
// Exports
module.exports = exports;
